export const PageHeader = ({ overline, title, description, actions }) => {
  return (
    <div className="no-print flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-6 mb-6 lg:pb-8 lg:mb-8 border-b border-border">
      <div>
        {overline && (
          <div className="overline text-primary mb-2 lg:mb-3" data-testid="page-overline">
            {overline}
          </div>
        )}
        <h1
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-foreground"
          data-testid="page-title"
        >
          {title}
        </h1>
        {description && (
          <p className="text-sm text-muted-foreground mt-2 lg:mt-3 max-w-xl">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{actions}</div>}
    </div>
  );
};

export default PageHeader;
